// extracted by mini-css-extract-plugin
export default {"container":"WorkspaceTable_container__wKhPn","actionButtonsContainer":"WorkspaceTable_actionButtonsContainer__E-rd7","content":"WorkspaceTable_content__YzSwK"};